<div class="popup-content">
    <div class="">
        <h3>Note</h3>
    </div>
    <div class="modal-body">
        <div class="row">
            <div class="col-12 row">
                <label class="f-w-6">Nội dung ghi chú </label>
                <textarea class="form-control" [(ngModel)]="note" rows="5"></textarea>
            </div>
        </div>

    </div>
    <div class="modal-footer w-100">
        <button class="ant-btn ng-star-inserted ant-btn-default" (click)="cancel()">Hủy bỏ</button>
        <button class="ant-btn ng-star-inserted ant-btn-primary" (click)="save()">Xác nhận</button>
    </div>
</div>